import PropTypes from 'prop-types';
import {Card, Typography, Checkbox, Divider, Grid} from '@material-ui/core';
import {useStyles} from 'Utility/styles';

function AclList(props) {
  const {aces = [], onChangeAce} = props;
  const classes = useStyles();

  return (
    <Card raised style={{marginLeft: 20, padding: 20}}>
      <Typography className={classes.rowTitleTypography} variant="subtitle1">
        <Grid container spacing={2}>
          <Grid item xs={3}>
            Teams
          </Grid>
          <Grid item xs={3}>
            Read
          </Grid>
          <Grid item xs={3}>
            Write
          </Grid>
          <Grid item xs={3}>
            Delete
          </Grid>
        </Grid>
      </Typography>
      <Divider />

      <Grid container>
        {aces.map((ace, row) => (
          <Grid
            container
            key={ace.id ? ace.id : row}
            className={classes.aceCell}
          >
            <Grid item xs={3}>
              <Typography className={classes.aceListTypography} variant="body1">
                {ace.team.name}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Checkbox
                className={classes.aceListCheckbox}
                label=""
                checked={ace.canread}
                onChange={() => onChangeAce(row, 1)}
              />
            </Grid>
            <Grid item xs={3}>
              <Checkbox
                className={classes.aceListCheckbox}
                label=""
                checked={ace.canwrite}
                onChange={() => onChangeAce(row, 2)}
              />
            </Grid>
            <Grid item xs={3}>
              <Checkbox
                className={classes.aceListCheckbox}
                label=""
                checked={ace.candelete}
                onChange={() => onChangeAce(row, 3)}
              />
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Card>
  );
}

AclList.propTypes = {
  aces: PropTypes.array.isRequired,
  onChangeAce: PropTypes.func.isRequired,
};

export default AclList;
